import styled from 'styled-components';
import { Button } from '@lt/components';

import { MAX_WIDTH } from '../constants';

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH}px;

  margin: auto;
`;

export const Container = styled.div<{ parentWidth?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= 1348) {
      return `max-width: calc(1348px - 16px);`;
    }
    if (parentWidth && parentWidth >= 1080) {
      return `max-width: calc(1080px - 16px);`;
    }
    return 'max-width: 1024px;';
  }}
`;

export const Description = styled.div`
  padding: 8px;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
  text-align: center;
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  > a:first-child {
    margin-bottom: 16px;
  }
`;

export const StyledButton = styled(Button)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    min-width: 280px;
    background-color: transparent;
  }
`;
